module.exports = __webpack_public_path__ + "img/rho-17-honig.ab0d9bfe.jpeg";